import { render, staticRenderFns } from "./RobberyDuringAbsenceQuestion.vue?vue&type=template&id=6f9bca0e&scoped=true"
import script from "./RobberyDuringAbsenceQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyDuringAbsenceQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9bca0e",
  null
  
)

export default component.exports